/**
 * Yoink Adventures - Slugify Utility
 *
 * Shared helper to convert strings to URL-safe slugs.
 * Used by router.js and user-panel views.
 */

/**
 * Convert a string to URL-safe slug
 * @param {string} str - String to slugify
 * @returns {string} URL-safe slug
 */
export function slugify(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove non-word chars
    .replace(/[\s_-]+/g, '-') // Replace spaces/underscores with hyphens
    .replace(/^-+|-+$/g, ''); // Trim hyphens from ends
}
